import React from "react";
import { Accordion } from "react-bootstrap";
import { BiMailSend } from "react-icons/bi";
const ContactDetails = () => {
  return (
    <div className='contactBox'>
      <div className='contactHeader'>
        <h3>Contact</h3>
      </div>
      <div className='AccordionBody'>
        <Accordion>
          <Accordion.Item eventKey='0'>
            <Accordion.Header>
              <h6 style={{ fontSize: "1.5rem" }}>
                For Email Id Related Queries
              </h6>
            </Accordion.Header>

            <Accordion.Body>
              <BiMailSend />
              <span>
                Email:{" "}
                <a href='mailto:it.support@jaipur.manipal.edu'>
                  it.support@jaipur.manipal.edu
                </a>
              </span>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey='1'>
            <Accordion.Header>
              <h6 style={{ fontSize: "1.5rem" }}>For Library Dues</h6>
            </Accordion.Header>
            <Accordion.Body>
              <strong>
                Mr. Om Prakash Verma <br />
              </strong>
              Mob: 9828543435
              <br /> <BiMailSend />
              <span>
                Email :{" "}
                <a href='mailto:omprakash.verma@jaipur.manipal.edu'>
                  omprakash.verma@jaipur.manipal.edu
                </a>
              </span>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey='2'>
            <Accordion.Header>
              <h6 style={{ fontSize: "1.5rem" }}>For Finance Dues</h6>
            </Accordion.Header>
            <Accordion.Body>
              <strong>
                Ms Monika Agrawal
                <br />
              </strong>
              Mob: 8003999672
              <br />
              <BiMailSend />
              <span>
                Email:{" "}
                <a href='mailto:Student.finance@jaipur.manipal.edu'>
                  Student.finance@jaipur.manipal.edu
                </a>
              </span>

            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey='3'>
            <Accordion.Header>
              <h6 style={{ fontSize: "1.5rem" }}>For Mess Dues:</h6>
            </Accordion.Header>
            <Accordion.Body>
              <strong>
                Mr. Sunil Kumawat <br />
              </strong>
              <BiMailSend />
              <span>
                Email:{" "}
                <a href='mailto:sunil.kumawat@bluspring.in' style={{ color: "red" }}>
                  sunil.kumawat@bluspring.in
                </a>
              </span>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey='4'>
            <Accordion.Header>
              <h6 style={{ fontSize: "1.5rem" }}>For Hostel Dues</h6>
            </Accordion.Header>
            <Accordion.Body>
              <strong>
                Mr. Madhusudan Sharma, GHSPL <br />
              </strong>
              Mob: 9467040958
              <br />
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey='5'>
            <Accordion.Header>
              <h6 style={{ fontSize: "1.5rem" }}>For AMS/Academics Dues </h6>
            </Accordion.Header>
            <Accordion.Body>
              <strong>
                Dr. Kusum Lata Jain <br />
              </strong>
              Phone: 0141-3999100 ext. 481, 784
              <br />
              <BiMailSend />
              <span>
                Email:{" "}
                <a href='mailto:kusumlata.jain@jaipur.manipal.edu'>
                  kusumlata.jain@jaipur.manipal.edu
                </a>
              </span>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey='6'>
            <Accordion.Header>
              <h6 style={{ fontSize: "1.5rem" }}>For Sports Dues</h6>
            </Accordion.Header>
            <Accordion.Body>
              <strong>
                Mr. Sanjeev Sharma <br />
              </strong>
              Mob: 9993308598
              <br />
              <BiMailSend />
              <span>
                Email:{" "}
                <a href='mailto:sanjeev.sharma@jaipur.manipal.edu'>
                  sanjeev.sharma@jaipur.manipal.edu
                </a>
              </span>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey='7'>
            <Accordion.Header>
              <h6 style={{ fontSize: "1.5rem" }}>
                For Exam cell related queries
              </h6>
            </Accordion.Header>
            <Accordion.Body>
              <strong>
                Mr. Bijendra Singh
                <br />
              </strong>
              <BiMailSend />
              <span>
                Email:{" "}
                <a href='mailto:it.support@jaipur.manipal.edu'>
                  brijendra.singh@jaipur.manipal.edu
                </a>
              </span>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey='8'>
            <Accordion.Header>
              <h6 style={{ fontSize: "1.5rem" }}>For Any Other Queries</h6>
            </Accordion.Header>
            <Accordion.Body>
              <span>
                Please fill out the MS Form using your MUJ Student ID/email ID (@muj.manipal.edu).
                <br />
                <strong>MS Form Link: </strong>
                <a
                  href='https://forms.cloud.microsoft/r/3Ve5TAXNUU'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  https://forms.cloud.microsoft/r/3Ve5TAXNUU
                </a>
              </span>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
};

export default ContactDetails;
